import React, { useState, useCallback } from 'react';
import {
  Box,
  useMediaQuery,
  useTheme
} from '@mui/material';
import PageTabs from '../Common/PageTabs';
import TradeHistoryDetails from './TradeHistoryDetails';
import PnlHistoryDetails from './PnlHistoryDetails';
import LedgerDetails from './LedgerDetails';

const TRADE_HISTORY_TABS = [
  { label: "Trade History", value: 0 },
  { label: "PnL History", value: 1 },
  { label: "Ledger", value: 2 },
];

const TradeHistory = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [activeTab, setActiveTab] = useState(0);
  
  const handleChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <PageTabs value={activeTab} onChange={handleChange} tabs={TRADE_HISTORY_TABS} sticky />
      <Box 
        sx={{ 
          flex: 1,
          height: isMobile ? 'calc(100% - 44px)' : 'calc(100dvh - 48px)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Box 
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            pt: { xs: 0.5, sm: 1, md: 2 },
            px: { xs: 0.5, sm: 1, md: 2 },
            pb: 0,
          }}
        >
          {activeTab === 0 && <TradeHistoryDetails />}
          {activeTab === 1 && <PnlHistoryDetails />}
          {activeTab === 2 && <LedgerDetails />}
        </Box>
      </Box>
    </Box>
  );
};

export default TradeHistory;